import {
  AJUSTE_DIA_NO_HABIL_OPTIONS,
  PoliticaVencimientoTipo,
  TIPO_POLITICA_OPTIONS,
} from './politica-vencimiento';
import type { PoliticaMail } from './politica-mail';

export const CATEGORIA_ACTIVIDAD_BASE = '/configuracion/workflow/categoria-actividad';

export function categoriaActividadListUrl(listSearch = ''): string {
  return `${CATEGORIA_ACTIVIDAD_BASE}${listSearch}`;
}

export function getCategoriaActividadListSearch(location: { state?: unknown }): string {
  const search = (location.state as { listSearch?: string } | null)?.listSearch;
  return typeof search === 'string' ? search : '';
}

export function categoriaActividadChildState(listSearch: string) {
  return { listSearch };
}

export interface TipoActividadDTO {
  id?: number;
  descripcion?: string;
}

export interface CategoriaActividadListDTO {
  id: number;
  descripcion?: string;
  tipoActividad?: TipoActividadDTO;
  aplicar?: boolean | null;
  nombre?: string | null;
  tipo?: PoliticaVencimientoTipo | null;
  desplazamiento?: number | null;
  ajusteDiaNoHabil?: string | null;
}

export interface CategoriaActividadDTO {
  id?: number;
  descripcion?: string;
  tipoActividad?: TipoActividadDTO;
  tipoDeVencimiento?: 'SAT' | 'PROFASE' | null;
  aplicarVencimiento?: boolean | null;
  vencimientoDia?: number | null;
  politicaMail?: PoliticaMail | null;
  requiereAutorizacion?: boolean | null;
  created?: string;
  createdBy?: number;
  updated?: string;
  updatedBy?: number;
}

export const APLICAR_POLITICA_FILTER_OPTIONS = [
  { value: 'true', label: 'Política activa' },
  { value: 'noaplicar', label: 'Sin política o inactiva' },
] as const;

export function getPoliticaTipoLabel(tipo?: string | null): string {
  if (!tipo) return '—';
  const opt = TIPO_POLITICA_OPTIONS.find(o => o.value === tipo);
  return opt?.label ?? tipo;
}

export function getAjusteDiaNoHabilLabel(ajuste?: string | null): string {
  if (!ajuste) return '—';
  const opt = AJUSTE_DIA_NO_HABIL_OPTIONS.find(o => o.value === ajuste);
  return opt?.label ?? ajuste;
}

export type { PoliticaMail, PoliticaMailAccion } from './politica-mail';
export { hasValidMailTemplate } from './politica-mail';

export function formatDesplazamiento(
  desplazamiento?: number | null,
  tipo?: string | null,
): string {
  if (desplazamiento == null || Number.isNaN(Number(desplazamiento))) {
    if (tipo === 'DIA_PERIODO' || tipo === 'DIA_SEMANA_MES') return '—';
    return '—';
  }
  const n = Number(desplazamiento);
  if (n === 0) return '0';
  return n > 0 ? `+${n}` : String(n);
}
